import React, { useCallback, useMemo, useState } from 'react';
import { Visibility } from 'semantic-ui-react';
import { Background, Description, DivRelative, Link, SubTitle } from '../../components/layouts';
import { buildImageURL, getTrack, pureTrans } from '../../helpers';
import LazyLoad from 'react-lazyload';

import './style.scss';

const IMAGES = {
  d: {
    i1: buildImageURL('/ltm-d-0.jpg'),
    i2: buildImageURL('/ltm-d-1.jpg')
  },
  m: {
    i1: buildImageURL('/ltm-m-0.jpg'),
    i2: buildImageURL('/ltm-m-1.jpg')
  }
};

const track = getTrack({ block: 20 });

export function LTM({ mobile = false }) {
  const [progress, setProgress] = useState(0);
  const { a1, a2 } = useMemo(() => {
    return {
      a1: pureTrans(progress, [0, 0.5], [1, 0], 3),
      a2: pureTrans(progress, [0, 0.5], [0, 1], 3)
    };
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed } }) => {
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility fireOnMount offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-ltm inverted" data-track={track}>
      <div className="sticky-content">
        <DivRelative>
          <LazyLoad>
            {!mobile && <Background active src={IMAGES.d.i1} opacity={a1} />}
            {!mobile && <Background active src={IMAGES.d.i2} opacity={a2} />}
            {mobile && <Background active src={IMAGES.m.i1} opacity={a1} />}
            {mobile && <Background active src={IMAGES.m.i2} opacity={a2} />}
          </LazyLoad>
          <div className="section-content left">
            <SubTitle>
              专业色准
              <br />
              真实还原，始终好看
            </SubTitle>
            <Description>
              X60 Pro+ 采用E3发光材料，且支持HDR10+技术，<br/>可有效保留视频的明暗细节。同时vivo针对屏幕进行<br/>逐片的色彩调校，无论看视频还是浏览网页，真实<br/>还原色彩、屏幕始终好看。
            </Description>
            <Link bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="购买我的X60 Pro+" position={20} />
          </div>
        </DivRelative>
      </div>
    </Visibility>
  );
}
